import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const REVIEW_REQUEST_SCHEMA = Object.freeze({
  ID: null,
  CREATED_DATE: null,
  EXPIRY_DATE: null,
  REVIEW_URL: '',
});
const RECORD = generateSchema(REVIEW_REQUEST_SCHEMA);
const KEYS: any = generateKeys(REVIEW_REQUEST_SCHEMA);

export class ReviewRequest extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): number {
    return this.get(KEYS.ID);
  }

  get createdDate(): string {
    return this.get(KEYS.CREATED_DATE);
  }

  get expiryDate(): string {
    return this.get(KEYS.EXPIRY_DATE);
  }

  get reviewUrl(): string {
    return this.get(KEYS.REVIEW_URL);
  }
}
